import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-container">

        <div className="footer-section">
          <h3>AWS Consulting</h3>
          <p>
            Designing scalable, production-ready systems on AWS.
          </p>
        </div>

        <div className="footer-section">
          <h4>Services</h4>
          <ul>
            <li><Link to="/services/aws-architecture">AWS Consulting & Architecture</Link></li>
            <li><Link to="/services/cloud-development">Cloud-Native Development</Link></li>
            <li><Link to="/services/optimization">Optimization & Maintenance</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Insights</h4>
          <ul>
            <li><Link to="/insights">All Insights</Link></li>
          </ul>
        </div>

        <div className="footer-section">
          <h4>Contact</h4>
          <Link to="/contact">Get in touch →</Link>
        </div>

      </div>

      <div className="footer-bottom">
        © {new Date().getFullYear()} Utilizing.Cloud
      </div>
    </footer>
  );
};

export default Footer;